<div class="download-asset-mode-title">
  <h1 class="title">Create Outputs Collection</h1>
</div>
<mat-dialog-content class="download-asset-model">
  <div class="output-setting">
    <mat-form-field appearance="outline" color="primary" style="width: 100%; margin-top: 8px">
      <mat-label>Collection Summary</mat-label>
      <input matInput [formControl]="summaryForm" />
      @if (summaryForm.value?.includes(' ')) {
        <mat-hint>
          <i>Spaces will be converted to underscores in the filename</i>
        </mat-hint>
      }
      @if (!summaryForm.value?.includes(' ')) {
        <mat-hint>
          <i>Optional summary to describe outputs in collection</i>
        </mat-hint>
      }
      @if (summaryForm.hasError('pattern')) {
        <mat-error>
          Collection name can only contain letters, numbers, spaces, hyphens, underscores, and dots
        </mat-error>
      }
    </mat-form-field>

    <div class="header">
      <i class="material-icons">inventory_2</i>
      <h3 class="title">Include in collection</h3>
    </div>

    <div class="header">
      <i class="material-icons">functions</i>
      <h3 class="title">Output formulas</h3>
    </div>
    <mat-button-toggle-group
      class="formula-mode-toggle"
      data-testid="formula-mode-toggle"
      [value]="mode.value"
      [disabled]="mode.disabled"
      [attr.disabled]="mode.disabled ? '' : null"
      (change)="onModeChanged($event.value)">
      <mat-button-toggle value="range">
        <mat-icon>format_list_numbered</mat-icon>
        Range
      </mat-button-toggle>
      <mat-button-toggle value="ev">
        <mat-icon>tune</mat-icon>
        EV
      </mat-button-toggle>
    </mat-button-toggle-group>
    <app-output-formula-picker
      [organizationId]="dataDialog.organizationId ?? ''"
      [mode]="mode.value"
      label="Output formulas"
      [showReviewFiles]="true"
      [reviewFilenamesDisabled]="isCheckFilenamesDisabled"
      [reviewFilesDisabled]="isCheckFilesDisabled"
      (selectionChange)="onFormulaSelectionChanged($event)"
      (reviewFilenamesRequested)="checkFilenames()"
      (reviewFilesRequested)="checkFiles()">
    </app-output-formula-picker>
    @if (isFormulaCategorySelected) {
      <div class="formula-coverage-summary" data-testid="formula-coverage-summary">
        {{ formulaCoverageSummary }}
      </div>
    }

    <hr class="category-divider">

    <app-collection-product-data-files-selection
      [formatsGeneratedInStep3]="formatsGeneratedInStep3"
      [pdfcConvention]="pdfcConvention"
      [filenameIdentifier]="pdfcIdentifier"
      [productIds]="dataDialog.productIds ?? []"
      [organizationId]="dataDialog.organizationId ?? ''"
      (selectionChange)="onProductDataFormatsChange($event)"
      (blockersChange)="onProductDataBlockersChange($event)">
    </app-collection-product-data-files-selection>

    @if (!hasAnyCategorySelected) {
      <div class="gate-hint">
        Select at least one category to include in the collection.
      </div>
    }

    @if (hasCategoryBlockers) {
      <div class="blockers-banner">
        <mat-icon>error</mat-icon>
        <div>
          <strong>Cannot proceed:</strong>
          {{ aggregateMissingCount }} file{{ aggregateMissingCount === 1 ? '' : 's' }} missing.
          Resolve them, or uncheck the affected category.
        </div>
      </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="action">
  <span style="flex: 1"></span>
  <button mat-stroked-button [mat-dialog-close]="DialogResult.Cancel">Cancel</button>
  <button mat-stroked-button color="success" class="save" cdkFocusInitial
    [disabled]="isCreateDisabled"
    (click)="create()">
    @if (isDownload) {
      <mat-icon><mat-spinner color="accent" diameter="20"> </mat-spinner></mat-icon>
    }Create
  </button>
</mat-dialog-actions>
